import { makeAuthPlugin } from "@/feathers-client";

export default makeAuthPlugin({
  entityIdField: "id",
  responseEntityField: "member",
  userService: "members",
});
